// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-sidenav {
  min-width: 305px !important;
  max-width: 305px !important;
}

.mat-mdc-button > .mat-icon {
  margin-right: 0px;
}

.spacer {
  flex: 1 1 auto;
}

.is-selected {
  background-color: rgba(236, 235, 235, 0.116) !important;
}

.link-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem;
}

.menu-button {
  transition: 300ms ease-in-out;
  transform: rotate(0deg);
}

.menu-button.rotated {
  transform: rotate(180deg);
}

.submenu {
  overflow-y: hidden;
  transition: transform 300ms ease;
  transform: scaleY(0);
  transform-origin: top;
}

.submenu.expanded {
  transform: scaleY(1);
}

.submenu.isShown {
  display: block !important;
}

.mat-drawer-container {
  height: calc(100vh - 64px) !important;
  background-color: #cccccc;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.bottom-page {
  position: absolute;
  bottom: 0;
  left: 0;
}

@media only screen and (max-width: 599px) {
  .mat-drawer-container {
    height: calc(100vh - 56px) !important;
    background-color: #cccccc;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/main/private/private-main.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,2BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,uDAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,6BAAA;EACA,uBAAA;AACF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,kBAAA;EACA,gCAAA;EACA,oBAAA;EACA,qBAAA;AAEF;;AACA;EACE,oBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,qCAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;AAEF;;AACA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AAEF;;AACA;EACE;IACE,qCAAA;IACA,yBAAA;IACA,2BAAA;IACA,4BAAA;IACA,sBAAA;EAEF;AACF","sourcesContent":["mat-sidenav {\r\n  min-width: 305px !important;\r\n  max-width: 305px !important\r\n}\r\n\r\n.mat-mdc-button>.mat-icon {\r\n  margin-right: 0px;\r\n}\r\n\r\n.spacer {\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.is-selected {\r\n  background-color: rgba(236, 235, 235, 0.116) !important;\r\n}\r\n\r\n.link-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 0.75rem;\r\n}\r\n\r\n.menu-button {\r\n  transition: 300ms ease-in-out;\r\n  transform: rotate(0deg);\r\n}\r\n.menu-button.rotated {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.submenu {\r\n  overflow-y: hidden;\r\n  transition: transform 300ms ease;\r\n  transform: scaleY(0);\r\n  transform-origin: top;\r\n}\r\n\r\n.submenu.expanded {\r\n  transform: scaleY(1);\r\n}\r\n\r\n.submenu.isShown {\r\n  display: block !important;\r\n}\r\n\r\n.mat-drawer-container {\r\n  height: calc(100vh - 64px) !important;\r\n  background-color: #cccccc;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\n.bottom-page {\r\n  position: absolute; \r\n  bottom: 0; \r\n  left: 0;\r\n}\r\n\r\n@media only screen and (max-width: 599px) {\r\n  .mat-drawer-container {\r\n    height: calc(100vh - 56px) !important;\r\n    background-color: #cccccc;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
